module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_114_18.cc82e80f.pdf";